import { useState, useEffect } from "react";
import { Space, Button, Row, Col, Input, Drawer, Checkbox, Select, Form } from "antd";
import { useGetBrandsQuery } from "../../redux/services/brandApi";

const { Option } = Select;

const FormSectionForm = (props: any) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const {
    isOpen,
    setOpen,
    isEditMode,
    addFormSection,
    setIsEditMode,
    onUpdateFormSection,
    selectedFormSection,
    setSelectedFormSection,
    formSectionBrands
  } = props;

  useEffect(() => {
    const fieldsValue = { ...selectedFormSection };
    form.setFieldsValue(fieldsValue);

    if (isEditMode && formSectionBrands?.length > 0) {
      form.setFieldsValue({
        form_section_brands_attributes: formSectionBrands.map((x: any) => x.brand?.id)
      });
    }
  }, [selectedFormSection, formSectionBrands, isEditMode, form]);

  const { data } = useGetBrandsQuery({ all_pages: true });
  const brands: any = data?.brands || [];

  const getSectionBrandsAttributes = (values: any) => {
    let form_section_brands_attributes = null;
    if (isEditMode) {
      form_section_brands_attributes = formSectionBrands.map((section_brand: any) => {
        if (values.form_section_brands_attributes?.includes(section_brand.brand.id)) {
          return { id: section_brand.id, brand_id: section_brand.brand.id };
        } else {
          return { id: section_brand.id, _destroy: true };
        }
      });
      const brandIds = formSectionBrands.map((section_brand: any) => section_brand.brand.id);
      const newBrandIds = values.form_section_brands_attributes.filter(
        (n: any) => !brandIds.includes(n)
      );
      newBrandIds.map((brandId: any) => {
        form_section_brands_attributes.push({ brand_id: brandId });
      });
    } else {
      form_section_brands_attributes = values.form_section_brands_attributes.map((brandId: any) => {
        return { brand_id: brandId };
      });
    }
    return form_section_brands_attributes;
  };

  const onFinish = (values: any) => {
    values.form_section_brands_attributes = getSectionBrandsAttributes(values);

    if (Object.keys(selectedFormSection).length === 0) {
      addFormSection({ section: values }, setLoading, form);
    } else {
      onUpdateFormSection({ section: values }, setLoading, form, selectedFormSection.id);
    }
  };

  const onFinishFailed = (errorInfo: any) => {
    console.log("Failed:", errorInfo);
  };

  const handleSelectAll = (value: any) => {
    if (value && value.length && value.includes("all")) {
      const all = brands.map((x: any) => x.id);
      form.setFieldsValue({
        form_section_brands_attributes: all
      });
    }
  };

  return (
    <Drawer
      title={`${isEditMode ? "Update" : "Create"} Section`}
      placement="right"
      closable={true}
      onClose={() => {
        setIsEditMode(false);
        form.resetFields();
        setSelectedFormSection({});
        setOpen(!isOpen);
      }}
      open={isOpen}
      destroyOnClose={true}
      key={"form-section-drawer"}
    >
      <Form
        name="form_section_form"
        form={form}
        initialValues={
          isEditMode
            ? {
                form_section_brands_attributes: formSectionBrands.map((x: any) => x.brand?.id)
              }
            : {
                add_to_report: true,
                use_in_installation: false,
                use_in_survey: false,
                use_in_visit: false
              }
        }
        labelCol={{ span: 24 }}
        wrapperCol={{ span: 24 }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
      >
        <Form.Item
          label="Name"
          name="name"
          rules={[
            { required: true, message: "Please input name" },
            { min: 3, message: "Name must be minimum 3 characters." },
            { max: 30, message: "Name must be maximum 30 characters." }
          ]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          name="section_type"
          label="Type"
          rules={[{ required: true, message: "Please select type" }]}
        >
          <Select
            placeholder="Select type"
            showSearch
            optionFilterProp="children"
            filterOption={(input, option: any) =>
              option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            <Option value="in_survey">In Survey</Option>
            <Option value="pre_survey">Pre Survey</Option>
            <Option value="post_survey">Post Survey</Option>
            <Option value="in_visit">In Visit</Option>
            <Option value="pre_visit">Pre Visit</Option>
            <Option value="post_visit">Post Visit</Option>
          </Select>
        </Form.Item>

        <Form.Item
          label="Position"
          name="position"
          rules={[{ required: true, message: "Please input name" }]}
        >
          <Input type="number" />
        </Form.Item>

        <Form.Item name="form_section_brands_attributes" label="Brands">
          <Select
            mode="multiple"
            placeholder="Please select brands"
            maxTagCount={5}
            onChange={handleSelectAll}
            showSearch
            optionFilterProp="children"
            filterOption={(input, option: any) =>
              option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            <Option key="all" value="all">
              ---SELECT ALL---
            </Option>
            {brands?.map((brand: any) => (
              <Option key={brand.id} value={brand.id}>
                {brand.name}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item label="Add to report" name="add_to_report" valuePropName="checked">
          <Checkbox />
        </Form.Item>

        <Form.Item label="Use in installation" name="use_in_installation" valuePropName="checked">
          <Checkbox />
        </Form.Item>

        <Form.Item label="Use in survey" name="use_in_survey" valuePropName="checked">
          <Checkbox />
        </Form.Item>

        <Form.Item label="Use in visit" name="use_in_visit" valuePropName="checked">
          <Checkbox />
        </Form.Item>

        <Form.Item
          name="status"
          label="Status"
          rules={[{ required: true, message: "Please select status" }]}
        >
          <Select
            placeholder="Select status"
            showSearch
            optionFilterProp="children"
            filterOption={(input, option: any) =>
              option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            <Option value="active">Active</Option>
            <Option value="inactive">Inactive</Option>
            <Option value="disabled">Disabled</Option>
          </Select>
        </Form.Item>

        <Form.Item wrapperCol={{ offset: 0, span: 24 }}>
          <Row>
            <Col>
              <Space size={"middle"}>
                <Button
                  type="default"
                  onClick={() => {
                    form.resetFields();
                    setSelectedFormSection({});
                    setOpen(!isOpen);
                  }}
                >
                  Cancel
                </Button>
                <Button type="primary" htmlType="submit" loading={loading}>
                  {isEditMode ? "Update" : "Add"}
                </Button>
              </Space>
            </Col>
          </Row>
        </Form.Item>
      </Form>
    </Drawer>
  );
};

export default FormSectionForm;
